module.exports = {"urls":["./build/ambiance.mp3"],"sprite":{"click":[0,240],"completed":[2000,7053.061224489795],"delete":[11000,1619.5918367346937],"enki":[14000,4571.42857142857],"find_codex":[20000,4075.102040816326],"message":[26000,5067.755102040816],"open":[33000,3119.9999999999973],"page":[38000,966.5306122448953],"recompense":[40000,3381.7687074829905],"selection":[45000,287.34693877551365],"spirits":[47000,6530.6122448979595],"succes":[55000,2351.020408163265]}}


//////////////////
// WEBPACK FOOTER
// ./src/components/sound/audio/ambiance.json
// module id = M/dy
// module chunks = 0